/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { OrderCustomerDtoUpdate } from '../../models/order-customer-dto-update';
import { OrderItemDetail } from '../../models/order-item-detail';

export interface OrderCustomerControllerEdit$Params {
  id: number;
      body: OrderCustomerDtoUpdate
}

export function orderCustomerControllerEdit(http: HttpClient, rootUrl: string, params: OrderCustomerControllerEdit$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderItemDetail;
}>> {
  const rb = new RequestBuilder(rootUrl, orderCustomerControllerEdit.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: OrderItemDetail;
      }>;
    })
  );
}

orderCustomerControllerEdit.PATH = '/order-customer/{id}';
